<template>
  <el-dialog
    :visible="visible"
    width="92%"
    custom-class="kc-detail-dialog"
    append-to-body
    @update:visible="$emit('close')"
  >
    <template v-slot:title>
      <div v-if="detail" class="kc-detail-heading">
        <span class="kc-detail-title">{{ detail.title }}</span>
        <badge v-if="detail.isAutomatic" type="info">{{ copy.adjustments.automatic }}</badge>
        <span class="kc-detail-date">{{ detail.date }}</span>
      </div>
    </template>
    <template v-if="detail">
      <kitchen-charge-line-groups v-if="isTicketEntry" :detail="detail" :currency="currency" />
      <dl v-else class="kc-adjustment-detail">
        <dt>{{ copy.adjustments.reason }}</dt>
        <dd>{{ detail.reason }}</dd>
        <dt>{{ copy.adjustments.amount }}</dt>
        <dd class="kc-adjustment-amount">{{ detail.amount }}</dd>
      </dl>
    </template>
  </el-dialog>
</template>

<script>
import { KITCHEN_CHARGES_COPY } from '@/components/KitchenCharges/copy';
import { isTicket } from '@/components/KitchenCharges/chargeEntries';
import { adjustmentDetail, ticketDetail } from '@/components/KitchenCharges/chargeDetails';
import KitchenChargeLineGroups from '@/components/KitchenCharges/KitchenChargeLineGroups.vue';

export default {
  name: 'KitchenChargeDetailDialog',
  components: { KitchenChargeLineGroups },
  props: {
    entry: { type: Object, default: null },
    currency: { type: String, required: true },
    visible: { type: Boolean, default: false },
  },
  data() {
    return { copy: KITCHEN_CHARGES_COPY };
  },
  computed: {
    isTicketEntry() {
      return Boolean(this.entry) && isTicket(this.entry);
    },
    detail() {
      if (!this.entry) return null;

      return this.isTicketEntry ? ticketDetail(this.entry, this.currency) : adjustmentDetail(this.entry, this.currency);
    },
  },
};
</script>

<style scoped>
.kc-detail-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 12px;
  padding-right: 24px;
}
.kc-detail-title {
  font-size: 1.0625rem;
  font-weight: 600;
  color: #32325d;
  word-break: break-all;
}
.kc-detail-date {
  flex-basis: 100%;
  font-size: 0.875rem;
  color: #8898aa;
}
.kc-adjustment-detail dt {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8898aa;
}
.kc-adjustment-detail dd {
  margin-bottom: 16px;
  color: #32325d;
}
.kc-adjustment-amount {
  font-size: 1.25rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
</style>

<style>
.kc-detail-dialog {
  max-width: 720px;
}
.kc-detail-dialog .el-dialog__body {
  padding-top: 8px;
}
</style>
